import { toast } from '@oy/uidesktop';

import merge from 'immutability-helper';
import { RequestManualTopupPayload } from 'src/models/ManualTopup';
import { reportFunctionError } from 'src/utilities/sentry';
import { ActionType, defaultAction } from '../types';
import { ACTION_TYPES } from '../types/manualTopupTypes';
type Nullable<T> = {
  [P in keyof T]: T[P] | null;
};

export type ManualTopupState = {
  email: string | null;
  requestId: string | null;
  isLoading: boolean;
  submitTime: string | null;
} & Nullable<RequestManualTopupPayload>;

const initialState: ManualTopupState = {
  requestId: null,
  email: null,
  isLoading: false,
  amount: null,
  submitTime: null,
  oy_payment_code: null,
  ref_number: null,
  receipt_key: null,
};

export default (state = initialState, action: ActionType = defaultAction) => {
  const { payload, type } = action;

  switch (type) {
    case ACTION_TYPES.MANUAL_TOPUP_REQUEST:
      return merge(state, {
        isLoading: {
          $set: true,
        },
      });
    case ACTION_TYPES.MANUAL_TOPUP_REQUEST_SUCCESS:
      const errorMessage =
        payload.error?.message || payload.reason || payload.message;
      if (!payload.success && errorMessage) {
        toast.error(errorMessage);
      }
      return {
        ...state,
        email: payload.data?.notif_email,
        requestId: payload.data?.tx_id,
        isLoading: false,
      };
    case ACTION_TYPES.MANUAL_TOPUP_REQUEST_FAILED:
      reportFunctionError({
        domain: 'dashboard',
        message: 'Failed to request manual topup',
        name: 'postManualTopupRequest',
        exception: payload,
        parentName: 'ManualTopupForm',
      });
      return merge(state, {
        isLoading: {
          $set: false,
        },
      });
    case 'resetManualTopup':
      return initialState;
    case 'submitManualTopup':
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};
